import {
  FormControl,
  Grid,
  InputLabel,
  Select,
  TextField,
  Typography,
  // Temp hiding email opt out flag
  // Checkbox,
  // FormControlLabel,
} from '@material-ui/core';

import React from 'react';
import { useContent } from 'utils/swrCalls';
import NumberFormat from 'react-number-format';
// Temp hiding email opt out flag
// import * as site from 'utils/getSite';

const ShippingAddressFields = (props) => {
  const { data: content } = useContent();
  const { states } = content?.content.form.global;
  const {
    values: {
      // Temp hiding email opt out flag
      // firstName, lastName, address1, address2, city, zipCode, state, phone, emailOptOut,
      firstName, lastName, address1, address2, city, zipCode, state, phone,
    },
    errors,
    handleChange,
    setFieldValue,
    header,
    hideNameFields,
  } = props;
  // const handleOptOut = () => {
  //   setFieldValue('emailOptOut', (emailOptOut === 0 ? 1 : 0), true);
  // };
  // Temporaraly setting the email opt in default to opt-in
  return (
    <div className='form-wrapper address-form'>
      <Typography variant='h4'>{header}</Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          {!hideNameFields && (
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <TextField
                id='firstName'
                name='firstName'
                variant='outlined'
                onChange={handleChange}
                error={Boolean(errors.firstName)}
                required
                defaultValue={firstName}
                margin='normal'
                label='First name'
                placeholder='First Name'
                fullWidth
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name='lastName'
                placeholder='Last Name'
                label='Last Name'
                onChange={handleChange}
                error={Boolean(errors.lastName)}
                required
                variant='outlined'
                defaultValue={lastName}
                margin='normal'
                fullWidth
              />
            </Grid>
          </Grid>
          )}
          <TextField
            name='address1'
            placeholder='Address 1'
            label='Address 1'
            onChange={handleChange}
            error={Boolean(errors.address1)}
            required
            variant='outlined'
            defaultValue={address1}
            margin='normal'
            fullWidth
          />
          <TextField
            name='address2'
            placeholder='Apartment, suite, unit, etc.'
            label='Address 2 (If applicable)'
            onChange={handleChange}
            variant='outlined'
            defaultValue={address2}
            margin='normal'
            fullWidth
          />
          {/* Temporaraly hiding the email opt out
          {site.getSite.includes('montblanc') && (
            <FormControlLabel
              margin='normal'
              className='no-bottom-margin'
              control={
                (
                  <Checkbox
                    color='primary'
                    checked={emailOptOut === 1}
                    onChange={handleOptOut}
                    value={emailOptOut}
                    inputProps={{ 'aria-label': 'email opt out checkbox', name: 'emailOptOut' }}
                  />
                )
              }
              label='Please send me email updates about Montblanc'
            />
          )} */}
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            name='city'
            placeholder='City'
            label='City'
            onChange={handleChange}
            error={Boolean(errors.city)}
            required
            variant='outlined'
            defaultValue={city}
            margin='normal'
            fullWidth
          />
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <TextField
                name='zipCode'
                placeholder='Zipcode'
                label='Zipcode'
                onChange={handleChange}
                error={Boolean(errors.zipCode)}
                required
                variant='outlined'
                defaultValue={zipCode}
                margin='normal'
                fullWidth
                inputProps={{
                  minLength: '5',
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl variant='outlined'>
                <InputLabel htmlFor='provider'>{'- Select State -'}</InputLabel>
                <Select
                  native
                  fullWidth
                  value={state}
                  onChange={handleChange}
                  labelWidth={105}
                  required
                  error={Boolean(errors.state)}
                  inputProps={{
                    name: 'state',
                  }}
                >
                  <option aria-label='None' value='' disabled />
                  {states.map((state) => (
                    <option value={state.abbreviation} key={state.abbreviation}>
                      {state.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <NumberFormat
              customInput={TextField}
              format='(###) ###-####'
              allowEmptyFormatting
              mask='_'
              name='phone'
              placeholder='Phone'
              label='Phone'
              onValueChange={(e) => e.floatValue && setFieldValue('phone', e.floatValue.toString())} // use NumberFormat output to give true value for validation
              error={Boolean(errors.phone)}
              required
              variant='outlined'
              defaultValue={phone}
              margin='normal'
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ShippingAddressFields;
